var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { ItemComponent } from "../app-home-work/home-work-item/item.component";
var HomeWorkShowComponent = (function () {
    function HomeWorkShowComponent(route, apiService, commonService, router) {
        this.route = route;
        this.apiService = apiService;
        this.commonService = commonService;
        this.router = router;
        this.className = 'response';
        this.tabNum = 0;
        this.isElseTeacherEvaluate = true; //学员作答是否有顾问点评
        this.myComment = ""; //我的作答顾问第一次点评
        this.myQuetionComment = ""; //我的作答顾问第二次点评
        this.submitAt = ""; //学员提交时间
        this.isComment = false; //是否有评论
        this.studentList = null; //学员作答
        this.myData = null; //我的作答
        this.isOpenClass = 0; //是否公开课
        this.selectedTag = "";
        this.collapse = true;
        this.relationIdArr = []; //学员作答relationId
        this.answerGroup = []; //学员作答答案
        this.theme = 'sight';
        this.appreciateList = [];
        this.isShowToast = false;
        this.destext = "您已经点过赞了";
        this.data = {};
        this.showCount = false; //在自己没点赞情况下展示点赞次数(大于0展示)
        this.ifshowData = false;
        this.isOnlyCamp = false; //只有训练营
        this.isLastDay = false; //是否是day7
        this.uploadId = ""; //查询上传文件条件
        this.isShowPreview = false; //是否显示预览
        this.text = "";
        this.isShowBackDesc = false; //是否展示背景描述
        this.homeworkCloseAtFlag = 0; //作答时间是否截止
        this.homeworkNoAnswer = 0; //作业是否未作答
    }
    HomeWorkShowComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.tabList = ['我的作答', '学员作答'];
        this.route.params.subscribe(function (params) {
            _this.lpmapcId = params['lpmapcId'];
        });
        this.route.queryParams.subscribe(function (queryParams) {
            _this.tabNum = queryParams['tabNum'];
            _this.learningPathMetaId = queryParams['learningPathMetaId'];
            _this.projectId = queryParams['projectId'];
            _this.homeworkCloseAtFlag = Number(queryParams['homeworkCloseAtFlag']);
        });
        if (this.learningPathMetaId) {
            localStorage.setItem("learningPathMetaId", this.learningPathMetaId);
        }
        else {
            localStorage.setItem("learningPathMetaId", "");
        }
        localStorage.removeItem("moduleId");
        this.test();
    };
    HomeWorkShowComponent.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getExerciseDetail(this.lpmapcId)];
                    case 1:
                        _a.exerciseGroup = _d.sent(); //题目数据
                        console.log('作业数据', this.exerciseGroup);
                        this.homeworkNoAnswer = this.exerciseGroup.status <= 10 ? 0 : 1;
                        _b = this;
                        return [4 /*yield*/, this.getMyAnswerEvaluate(this.lpmapcId)];
                    case 2:
                        _b.myData = _d.sent(); //我的作答数据
                        return [4 /*yield*/, this.getStudentList()];
                    case 3:
                        _d.sent(); //学员作答数据
                        _c = this;
                        return [4 /*yield*/, this.getAppreciate()];
                    case 4:
                        _c.appreciateList = _d.sent(); //获取点赞列表
                        return [4 /*yield*/, this.mockData()];
                    case 5:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeWorkShowComponent.prototype.getStudentList = function () {
        var _this = this;
        return this.getStudentAnswers(this.lpmapcId).then(function (result) {
            _this.studentList = result.studentAnswerVOList;
        });
    };
    HomeWorkShowComponent.prototype.mockData = function () {
        var _this = this;
        var self = this;
        this.exerciseType = this.exerciseGroup.homeworkAppendixList.length === 0 ? 1 : 5;
        this.ifshowData = true;
        this.myData.userClick = false;
        this.exerciseGroup.str = this.exerciseGroup.userAnswer;
        //我的作答自己是否点赞判断
        self.appreciateList.forEach(function (item) {
            if (item.userHomeworkRelationId == self.myData.relationId) {
                self.myData.userClick = true;
            }
        });
        //学员作答自己是否点赞情况判断
        self.studentList.forEach(function (item) {
            self.appreciateList.forEach(function (itm) {
                if (item['userCampExerciseQuestionOperationLogVO'].relationId == itm.userHomeworkRelationId) {
                    item.userClick = true;
                }
            });
        });
        setTimeout(function () {
            _this.judjeHeight();
        }, 100);
    };
    //判断高度是否达到可展开收拢高度
    HomeWorkShowComponent.prototype.judjeHeight = function () {
        if (this.tabNum == 0) {
            this.myData.showOpen = 0;
            var exerciseWorkBox = document.getElementById("exercise-work-box-" + this.myData.relationId);
            if (this.myData.comment != '' && this.myData.comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight > 220) {
                this.myData.showOpen = 1;
            }
        }
        else if (this.tabNum == 1) {
            this.studentList.forEach(function (item) {
                item.showOpen = 0;
                // 有评论且高度达到
                var exerciseWorkBox = document.getElementById("exercise-work-box-" + item['userCampExerciseQuestionOperationLogVO'].relationId);
                if (item['userCampExerciseQuestionOperationLogVO'].comment != "" && item['userCampExerciseQuestionOperationLogVO'].comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight > 200) {
                    item.showOpen = 1;
                }
            });
        }
    };
    //背景描述
    HomeWorkShowComponent.prototype.backgroundDesc = function () {
        this.isShowBackDesc = !this.isShowBackDesc;
    };
    HomeWorkShowComponent.prototype.getLearningPathMetaId = function () {
        //根据LearningPathMetaId判断获取是第几单元为了外链进入到作答页面后返回课程列表页是第几单元
        if (this.isFirstDay) {
            if (Number(localStorage.getItem("campId")) === 1 || Number(localStorage.getItem("campId")) === 3) {
                localStorage.setItem("campCourseDay", "Start Day");
            }
            else {
                localStorage.setItem("campCourseDay", "Day1");
            }
        }
        else if (this.isLastDay) {
            if (Number(localStorage.getItem("campId")) === 1) {
                localStorage.setItem("campCourseDay", "综合检测");
                localStorage.setItem("learningPathMetasId", "-49601");
            }
            else if (Number(localStorage.getItem("campId")) === 3) {
                localStorage.setItem("campCourseDay", "综合检测");
                localStorage.setItem("learningPathMetasId", "-429601");
            }
            else {
                localStorage.setItem("campCourseDay", "Day14");
                localStorage.setItem("learningPathMetasId", "-419601");
            }
        }
        else {
            if (this.learningPathId) {
                this.apiService.ajax({
                    'type': 'get',
                    'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
                }).subscribe(function (result) {
                    switch (result.data) {
                        case 4192:
                            localStorage.setItem("campCourseDay", "Day2&3");
                            break;
                        case 492 || 4292:
                            localStorage.setItem("campCourseDay", "沟通原则");
                            break;
                        case 412:
                            localStorage.setItem("campCourseDay", "Day4&5");
                            break;
                        case 402 || 422:
                            localStorage.setItem("campCourseDay", "互动流程");
                            break;
                        case 416:
                            localStorage.setItem("campCourseDay", "Day6&7");
                            break;
                        case 406 || 426:
                            localStorage.setItem("campCourseDay", "目标设定");
                            break;
                        case 413:
                            localStorage.setItem("campCourseDay", "Day8&9");
                            break;
                        case 403 || 423:
                            localStorage.setItem("campCourseDay", "任务授权");
                            break;
                        case 415:
                            localStorage.setItem("campCourseDay", "Day10&11");
                            break;
                        case 405 || 425:
                            localStorage.setItem("campCourseDay", "辅导他人");
                            break;
                        case 4196:
                            localStorage.setItem("campCourseDay", "Day12&13");
                            break;
                        case 496 || 4296:
                            localStorage.setItem("campCourseDay", "绩效追踪");
                            break;
                    }
                });
            }
        }
    };
    HomeWorkShowComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'rgba(40,51,130,1)'
        });
    };
    /**
     * 获取答题界面用户上传列表
     * @param tabNum: Number  nav下标
     */
    HomeWorkShowComponent.prototype.getAnswerUploadList = function (tabNum) {
        var _this = this;
        if (tabNum === 0) {
            var index = this.commonService.getIndexByConditionIdInLists(this.exerciseGroup['questionGroup'], 'type', 5);
            if (index >= 0) {
                this.uploadId = this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
                this.getCampFile({ 'constituteId': this.constituteId, 'questionId': this.exerciseGroup['questionGroup'][index]['questionId'], 'campFileUploadIds': this.uploadId }).then(function (result) {
                    _this.uploadList = result['newFileList'];
                });
            }
            else {
                this.uploadList = [];
            }
        }
    };
    HomeWorkShowComponent.prototype.tabIndex = function (i) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ifshowData = false;
                        this.tabNum = i;
                        //切换tab时滚动到顶部
                        return [4 /*yield*/, this.test()];
                    case 1:
                        //切换tab时滚动到顶部
                        _a.sent();
                        $('.wrap').scrollTop(0);
                        return [2 /*return*/];
                }
            });
        });
    };
    //我的作答展开
    HomeWorkShowComponent.prototype.myOpen = function (flag) {
        this.myData.showOpen = flag == 1 ? 2 : 1;
        //点击收拢的时候回到顶部
        if (this.myData.showOpen == 1) {
            //跳转到对应位置
            var ele = document.querySelector(".my");
            ele.scrollTop = 0;
        }
    };
    HomeWorkShowComponent.prototype.studentOpen = function (relationId) {
        this.studentList.map(function (item) {
            if (item['userCampExerciseQuestionOperationLogVO'].relationId == relationId) {
                item.showOpen = item.showOpen == 1 ? 2 : 1;
            }
        });
        //跳转到对应位置
        var ele = document.querySelector(".comment_wrap-" + relationId);
        ele.scrollIntoView();
    };
    //返回
    HomeWorkShowComponent.prototype.exit = function () {
        var learningPathMetaId = null;
        var projectId = null;
        this.route.queryParams.subscribe(function (queryParams) {
            learningPathMetaId = queryParams['learningPathMetaId'];
            projectId = queryParams['projectId'];
        });
        localStorage.setItem("projectId", this.exerciseGroup.projectId);
        if (learningPathMetaId) {
            this.router.navigate(['learning-path', learningPathMetaId]);
        }
        else {
            this.router.navigate(['learning-project', projectId]);
        }
    };
    HomeWorkShowComponent.prototype.setBodyHeight = function (event) {
        this.bodyHeight = event + 'rem';
    };
    //我的作答点赞
    HomeWorkShowComponent.prototype.getMyAppreciate = function () {
        this.myData.appreciateCount += 1;
        this.myData.userClick = true;
    };
    //学员点赞
    HomeWorkShowComponent.prototype.getStudentAppreciate = function (obj) {
        obj.studentList.map(function (item) {
            if (item['campExerciseQuestionGroupMetaVO'].relationId == obj.relationId) {
                item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1;
                item.userClick = true;
            }
        });
        this.studentList = obj.studentList;
    };
    HomeWorkShowComponent.prototype.getShowToast = function (flag) {
        var _this = this;
        this.isShowToast = flag;
        if (this.isShowToast) {
            setTimeout(function () {
                _this.isShowToast = false;
            }, 2000);
        }
    };
    //点赞
    HomeWorkShowComponent.prototype.giveAppreciate = function (data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/user/project/homework/saveOperationLog',
            'data': data
        }).toPromise();
    };
    //点赞列表
    HomeWorkShowComponent.prototype.getAppreciate = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': 'ddilearner/v2/user/project/homework/getOperationLogList/3',
        }).toPromise();
    };
    //获取上传文件列表
    HomeWorkShowComponent.prototype.getCampFile = function (data) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': 'ddilearner/v2/user/project/homework/getHomeworkFileList',
            'data': data
        }).toPromise();
    };
    //根据试卷ID获取当前试卷所有小题题目
    HomeWorkShowComponent.prototype.getExerciseDetail = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/project/homework?homeworkDuplicateId=' + lpmapcId,
        }).toPromise();
    };
    //获取我的作答数据
    HomeWorkShowComponent.prototype.getMyAnswerEvaluate = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/project/homework/getMyAnswer/' + lpmapcId
        }).toPromise();
    };
    //获取学员作答数据
    HomeWorkShowComponent.prototype.getStudentAnswers = function (lpmapcId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/project/homework/getStudentAnswer/' + lpmapcId
        }).toPromise();
    };
    /**
     * 预览
     * @param event:Object   子组件传递来的预览对象
     */
    HomeWorkShowComponent.prototype.showReview = function (event) {
        console.log(11111111111111);
        this.previewSource = event;
        this.isShowPreview = true;
    };
    /**
     * 关闭预览
     */
    HomeWorkShowComponent.prototype.closePreview = function () {
        this.isShowPreview = false;
    };
    return HomeWorkShowComponent;
}());
export { HomeWorkShowComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-show.component.ts.pre-build-optimizer.js